var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 768",
    height: "768px",
    width: "1024px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    spreadMethod: "pad",
    y2: "30%",
    x2: "-10%",
    y1: "120%",
    x1: "30%",
    id: "gradient1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "rotate(-30)",
    spreadMethod: "pad",
    y2: "30%",
    x2: "-10%",
    y1: "120%",
    x1: "30%",
    id: "gradient2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#cccccc",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.16139,125.56009c1.51221,0,2.95227.57605,4.03235,1.65616,3.52832,3.4563,7.12866,4.46439,11.88098,4.46439,4.68042,0,8.28076-1.00809,11.73706-4.3924,1.08008-.93607,2.52026-1.58411,4.03235-1.58411,3.31238,0,5.90454,2.66422,5.90454,5.90448,0,1.80017-.79211,3.31232-1.94421,4.46442-5.83252,5.25644-12.6731,7.48865-19.72974,7.48865s-14.04114-2.3042-19.94568-7.70468c-1.1521-1.1521-1.94421-2.66422-1.94421-4.32037,0-3.24026,2.59229-5.97653,5.97656-5.97653Z",
    fill: "#8f8b79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.07472,74.50769c-13.17725,0-24.19385,10.80078-24.19385,24.05029,0,13.46484,11.0166,24.26562,24.19385,24.26562,13.24951,0,24.05029-10.80078,24.05029-24.26562,0-13.24951-10.80078-24.05029-24.05029-24.05029Z",
    fill: "#0a0a0a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradify);
export default __webpack_public_path__ + "static/media/gradify.764ef202344844e89f854ec3c1f92563.svg";
export { ForwardRef as ReactComponent };